export const isIncludeSubDomains = (isWWW: string) => {
    const ALL_DOMAINS_PREFIX = "*";
    return isWWW === ALL_DOMAINS_PREFIX;
};
